import React, { useState, useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from ".";
import {
  getBrightspeedToken,
  setHeaders,
} from "../SharedContextStore/slices/brightspeedToken";
import { getSessionId } from "../SharedContextStore/slices/user";
import { webRefreshTokenRedux } from "../../../shared/utils/Constants";
import store from "../SharedContextStore/store";
import { getAzureInfo } from "../../../shared/hooks/useFetchLogin";

export default function useBrightspeedHeaders() {
  const dispatch = useAppDispatch();
  const headers = useAppSelector((state) => state?.brightspeedToken?.headers);
  const globalToken = useAppSelector((state) => state?.brightspeedToken?.data);
  const sessionId = useAppSelector((state) => state?.user?.sessionId);
  const refreshToken = useAppSelector((state) => state?.user?.refreshToken);
  const brightSpeedFiberIndicator = useAppSelector(
    (state) =>
      state?.addressQualification?.data?.addressQualification?.entity
        ?.brightSpeedFiberIndicator
  );
  const hasFetched=useRef(false)
  const AddressQualificationSiteId = useAppSelector(
    (state) =>
      state?.addressQualification?.data?.addressQualification?.entity?.siteId
  );
  const instantInternet = useAppSelector(
    (state) =>
      state?.addressQualification?.data?.addressQualification?.entity
        ?.instantInternet
  );

  useEffect(() => {
    if (
      !globalToken?.access_token &&
      process.env.REACT_APP_ENV === "production" &&
      !headers?.Authorization
    ) {
      const source = {
        refreshToken: async () => await dispatch(getBrightspeedToken()),
        webReduxStore: store,
      };
      Object.assign(webRefreshTokenRedux, source);
      getBrightspeedTokenSync();
    }
  }, []);

  useEffect(() => {
    if (
      !localStorage.getItem("sessionId") &&
      !headers?.sessionId &&
      ((process.env.REACT_APP_ENV === "production" &&
        globalToken?.access_token &&
        headers?.Authorization) ||
        process.env.REACT_APP_ENV !== "production") &&
        !hasFetched.current
    ) {
      hasFetched.current=true
      getSessionDetails();
    }
  }, [globalToken]);

  useEffect(() => {
    if (globalToken?.access_token && !headers?.Authorization) {
      dispatch(
        setHeaders({
          ...headers,
          Authorization: `Bearer ${globalToken?.access_token}`,
        })
      );
    }
  }, [globalToken]);

  useEffect(() => {
    if (sessionId && headers?.sessionId !== sessionId) {
      dispatch(
        setHeaders({
          ...headers,
          sessionId: sessionId,
        })
      );
    }
  }, [sessionId]);

  useEffect(() => {
    if (refreshToken && headers?.["refresh-token"] !== refreshToken) {
      dispatch(
        setHeaders({
          ...headers,
          "refresh-token": refreshToken,
        })
      );
    } else if (!refreshToken && headers?.["refresh-token"]) {
      const tempHeader = {...headers}
      delete tempHeader['refresh-token'];
      dispatch(
        setHeaders({
          ...tempHeader
        })
      );
    }
  }, [refreshToken]);

  useEffect(() => {
    if(AddressQualificationSiteId && !headers?.siteId){
      if (
        (["QF_QUALIFIED", "QF QUALIFIED"]?.includes(
          brightSpeedFiberIndicator?.toUpperCase()
        ) && instantInternet) || AddressQualificationSiteId?.toLowerCase() === "qf-ii"
      ) {
        
        localStorage.setItem("headersSiteId","qf-ii");
        dispatch(
          setHeaders({
            ...headers,
            siteId: AddressQualificationSiteId || "qf-ii",
          })
        );
      }
    }
  }, [AddressQualificationSiteId]);

  const getBrightspeedTokenSync = async () => {
    await dispatch(getBrightspeedToken());
  };

  const getSessionDetails = async () => {
    await dispatch(getSessionId());
  };

  return headers;
}
